<div class="forgotPwWrapper">
  <span class="headline">Passwort vergessen?</span>
  <span class="text">Wir senden Ihnen einen Wiederherstellungslink an folgende E-Mail-Adresse:</span>
  <form class="marginTop" data-private>
    <span class="label">EMAIL</span>
    <mat-form-field class="form-field" appearance="outline">
      <input placeholder="Email address" matInput [formControl]="email" type="email" class="form-control" required />
    </mat-form-field>
    <button class="saveButton" mat-flat-button [disabled]="email.invalid" [class.correct]="email.valid" (click)="requestPwReset()">
      WIEDERHERSTELLUNGSLINK SENDEN
    </button>
  </form>
  <div class="row marginTop">
    <button mat-flat-button class="questionButton" (click)="leave()">
      Abbrechen
    </button>
  </div>
</div>
